import {Directive, ElementRef, HostListener, inject} from '@angular/core';

@Directive({
  selector: '[input[numbersOnly]]'
})
export class NumbersOnlyDirective {
    private _el = inject(ElementRef);
    constructor() {}

    @HostListener('input', ['$event']) onInputChange() {
        const initalValue = this._el.nativeElement.value;
        let newValue = initalValue.replace(/[^0-9]*/g, '');
        newValue = Number.parseInt(newValue);
        newValue = isNaN(newValue) || !newValue ? 0 : newValue
        this._el.nativeElement.value = newValue;
    }
}
